import React from 'react';

const ID = 'slider-input';

export interface SliderInputProps {
    id?: string;
    onChange?: (value: boolean) => void;
    onFocusChange?: () => void;
    value?: boolean;
    label: React.ReactNode;
    autoFocus?: boolean;
    disabled?: boolean;
    submitted?: boolean;
    className?: string;
}

export const SliderInput = (props: SliderInputProps) => {
    const handleClick = () => {
        if (!props.disabled && props.onChange) {
            props.onChange(!props.value);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            id={ID}
            className={`flex items-center gap-3 ${props.className || ''}`}>
            <div
                role='switch'
                aria-checked={props.value}
                aria-disabled={props.disabled}
                tabIndex={props.disabled ? -1 : 0}
                className={`relative h-[24px] w-[40px] rounded-full overflow-clip transition-colors duration-200 ease-in-out ${
                    props.disabled
                        ? 'opacity-50 cursor-not-allowed'
                        : 'cursor-pointer'
                } ${props.value ? 'bg-brand-primary' : 'bg-brand-muted'}`}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                onFocus={() => {
                    props.onFocusChange && props.onFocusChange();
                }}>
                <div
                    className={`absolute top-1/2 size-[18px] -translate-y-1/2 rounded-full bg-background-surface shadow-sm transition-all duration-200 ease-in-out ${
                        props.value ? 'left-[19px]' : 'left-[3px]'
                    }`}
                />
            </div>
            <label
                className={`text-foreground-default text-base font-medium ${
                    props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                }`}
                onClick={handleClick}>
                {props.label}
            </label>
        </div>
    );
};
